import React from 'react';
import cs from 'classnames';
import trim from 'lodash/trim';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import Spinner from '~/components/common/Spinner';
import store from '~/store';
import config from '~/config';
import ConcactInfo from './ContactInfo';
import CompanyInfo from './CompanyInfo';
import BillingInfomation from '../MyAccount/share/BillingInfomation';
import {errorInfoConfig} from '~/misc/error-info';
import {regEmail, regZip, regZipCanada, regPhone, regDot, regMc} from '~/misc/reg';
import {formatPhone, formatNumberOnly, formatCanadaZip, nonZero} from '~/misc/formatPhone';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {
  queryAccountOrNot,
  getDirectOrderPayOption,
  saveDirectOrderInfoActions,
  hideAsyncErrorMessage,
} from '~/modules/createAccount/actions';
import {centTo$} from '~/misc/formatMoney';
import {getFetchedJSON} from '~/misc/fetch';
import { getELDUserInfo } from './api';
import { removeELDToken } from './cookie';

import css from './index.css';
import sharedCSS from '~/components/shared.css';
import inputCSS from '../MyAccount/share/Input/index.css';

class CreateAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipType: '',
      showDotInput: true,
      createAccountInfo: {
        contactId: '',
        salesCode: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
      companyInfo: {
        companyDot: '',
        companyMc: '',
        company: '',
        plan: '',
        billing: '',
        user: '1',
        discountPrice: '',
      },
      billingInfo: {
        billFirstname: '',
        billLastname: '',
        billPhone: '',
        billEmail: '',
        billAddress: '',
        billCity: '',
        billState: 'AK',
        billCountry: 'United States',
        billZip: '',
      },
      formControl: {},
      eldUserInfo: {}
    };
    this.urlInput = null;
    this.changeDotOrMC = this.changeDotOrMC.bind(this);
    this.copyUrl = this.copyUrl.bind(this);
    this.previewUrl = this.previewUrl.bind(this);
    this.renderContext = this.renderContext.bind(this);
  }

  componentWillMount() {
    this.props.getDirectOrderPayOption();
    this.getELDUser()
  }

  componentWillReceiveProps(nextProps) {
    const paymentInfo = nextProps.createAccount.paymentInfo;
    const paymentInfoData = nextProps.createAccount.paymentInfo.data;
    if (isEmpty(this.props.createAccount.paymentInfo.data)
      && !isEmpty(nextProps.createAccount.paymentInfo.data)) {
      const obj = {};
      if (!this.state.companyInfo.plan) {
        obj.plan = paymentInfo.plan[0];
        obj.discountPrice = paymentInfoData[paymentInfo.plan[0]][0].discount_price;
      }
      if (!this.state.companyInfo.billing && this.state.companyInfo.plan) {
        obj.billing = paymentInfoData[this.state.companyInfo.plan][0].show_name;
      }
      if (!this.state.companyInfo.billing && !this.state.companyInfo.plan) {
        obj.billing = paymentInfoData[paymentInfo.plan[0]][0].show_name;
      }
      this.setState({
        companyInfo: Object.assign({}, this.state.companyInfo, obj),
      });
    }
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const eldUserInfo = this.state.eldUserInfo
    const {paymentInfo, saveDirectOrderInfo} = this.props.createAccount;
    const billingData = paymentInfo.data[this.state.companyInfo.plan] || []
    const info = billingData.filter(x => x.show_name == this.state.companyInfo.billing)[0] || {}
    let show_description = (info.show_description || '').toString()
    show_description = show_description.replace(/{[0-9]*}/g, value => 
      centTo$(Number(value.replace(/\D/g, '')) * Number(this.state.companyInfo.user))
    )
    if (eldUserInfo.requested && !eldUserInfo.isShow && eldUserInfo.state === 'permissionDenied') {
      return (
        <div className={cs(css.viewH)} >
          <p className={css.txtCenter}>
            Sorry, you do not have the access of this function. Please confirm with your team leader.
          </p>
        </div>
      )
    }
    if (eldUserInfo.requested && !eldUserInfo.isShow && eldUserInfo.state === 'serviceError') {
      return (
        <div className={cs(css.viewH)} >
          <p className={css.txtCenter}>
            An error occured.(
              <a href={config.eldUrl + '/sales'}>Back to home page.</a>
            )
          </p>
        </div>
      )
    }
    if (eldUserInfo.requested && eldUserInfo.isShow && paymentInfo.error) {
      return (
        <div className={cs(css.viewH)} >
          <p className={css.txtCenter} onClick={this.props.getDirectOrderPayOption}>{paymentInfo.error}</p>
        </div>
      );
    }

    if (eldUserInfo.requested && eldUserInfo.isShow && !isEmpty(paymentInfo.data)) {
      return (
        <div>
          {
            this.renderContext()
          }
          <div className={css.partWrap}>
            <div className={css.tit}>1、 Contact Information</div>
            <ConcactInfo
              createAccountInfo={
                this.state.createAccountInfo
              }
              errorControl={
                this.state.formControl
              }
              handleChange = {
                (e) => this.handleChangeInput('createAccountInfo', e)
              }
              handleBlur={
                (e) => this.handleBlur('createAccountInfo', e)
              }
              handleBlurEmail={
                (e) => this.handleBlurContactEmailInput('createAccountInfo', e)
              }
            />
          </div>
          <div className={css.partWrap}>
            <div className={css.tit}>2、Company Information</div>
            <CompanyInfo
              paymentInfo={
                paymentInfo
              }
              showDotInput={
                this.state.showDotInput
              }
              companyInfo={
                this.state.companyInfo
              }
              changeDotOrMC = {
                this.changeDotOrMC
              }
              errorControl={
                this.state.formControl
              }
              handleToggle={
                (e) => this.handleToggle('companyInfo', e)
              }
              handleChange={
                (e) => this.handleChangeInput('companyInfo', e)
              }
              handleBlur={
                (e) => this.handleBlur('companyInfo', e)
              }
              blurDotMc={
                (e) => this.blurDotMc('companyInfo', e)
              }
            />
            <div className={css.totalPrice}>Price:{' '}
              <span className={css.red}>
                { show_description }
              </span>
            </div>
          </div>
          <div className={css.partWrap}>
            <div className={css.tit}>3、 Billing Information</div>
            <BillingInfomation
              billingInfo = {
                this.state.billingInfo
              }
              errorControl = {
                this.state.formControl
              }
              handleToggle = {
                (e) => this.handleToggle('billingInfo', e)
              }
              handleChange = {
                (e) => this.handleChangeInput('billingInfo', e)
              }
              handleBlur = {
                (e) => this.handleBlur('billingInfo', e)
              }
            />
            <div className={css.fixclear}>
              {saveDirectOrderInfo && !saveDirectOrderInfo.error && (
                <div className={css.errorTipsWrap}>
                  {
                    hideErrorMsg('saveDirectOrderInfo', saveDirectOrderInfo, hideAsyncErrorMessage)
                  }
                </div>
              )}
              {
                saveDirectOrderInfo.error && saveDirectOrderInfo.error
              }
            </div>
          </div>
          <div className={css.btnWrap}>
            <Button className={cs(css.wide)}
              onClick={() => this.saveDirectInfo()}
              mods={['large', 'action']}
            >Save</Button>
          </div>
          <div className={cs(css.partWrap)}>
            <div className={css.tit}>Link</div>
            <div className={css.footer}>
              <div className={css.inputWrap}>
                <input
                  className={inputCSS.input}
                  type='text'
                  ref={(input) => {this.urlInput = input;}}
                  autoComplete='off'
                  readOnly='true'
                  value={saveDirectOrderInfo.orderUrl}
                />
              </div>
              <div
                className={cs(css.copyWrap, this.state.tipType && css.tips)}
                onClick={this.copyUrl}
                data-tip={this.state.tipType}
              >
                <Button mods={['large', 'action']} >Copy</Button>
              </div>
              {/* <Button mods={['large', 'action']} onClick={this.previewUrl}>Preview</Button> */}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={css.viewH}>
        <div className={cs(css.spinnerLine, css.pdtop)}>
          <div className={cs(css.spinner, css.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  renderContext(){
    try {
      let platform = this.props.createAccount.queryAccount.data.platform
      const accountPlan = this.props.createAccount.queryAccount.data.member_plan
      const accountCycle = this.props.createAccount.queryAccount.data.bill_cycle
      switch(platform) {
        case 'Bundle':
          platform = 'ELD Bundle'
          break
        case 'Web':
          platform = 'Stripe'
          break
        case 'BackOffice':
          platform = 'Backoffice for free'
      }
      if (platform && accountPlan && accountCycle) {
        return <div className={css.toastTip}>
          User has subscribed {accountPlan} {accountCycle} Plan from {platform}
        </div>;
      }
    } catch (error) {
      console.log(error)
    }
  }

  copyUrl(e) {
    const {orderUrl} = this.props.createAccount.saveDirectOrderInfo;
    if (!orderUrl) {
      return null;
    }
    this.urlInput.select();
    document.execCommand('Copy', false, false);
    setTimeout(() => {
      this.setState({
        tipType: '',
      });
    }, 2000);
    return this.setState({
      tipType: 'Copied',
    });
  }

  previewUrl() {

  }

  saveDirectInfo() {
    const {paymentInfo, saveDirectOrderInfo} = this.props.createAccount;
    const {loading} = saveDirectOrderInfo;
    if (loading) {
      return false;
    }
    const data = Object.assign(
      {},
      this.state.createAccountInfo,
      this.state.companyInfo,
      this.state.billingInfo);
    const connectFormValue = Object.assign({}, data);

    let emptyValue = {};

    // dot 和 mc  有一项存在即可
    if (connectFormValue.companyDot || connectFormValue.companyMc) {
      delete connectFormValue.companyDot;
      delete connectFormValue.companyMc;
    } else {
      delete connectFormValue.companyMc;
    }

    Object.keys(connectFormValue).forEach((key) => {
      if (
        key === 'companyMc'
        || key === 'contactId'
        || key === 'salesCode'
        || key === 'companyDot'
        || key === 'company'
      ) {
        return;
      } else if (!connectFormValue[key]) {
        // judge empty value except MC
        if (key === 'billEmail' || key === 'email') {
          emptyValue[key] = {
            error: errorInfoConfig.email.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'companyDot') {
          emptyValue[key] = {
            error: errorInfoConfig.dot.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'billZip') {
          emptyValue[key] = {
            error: errorInfoConfig.zip.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'billPhone' || key === 'phone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      }
    });

    if (isEmpty(emptyValue)) {
      // 存储数据前格式化电话号码
      if (data.phone) {
        data.phone = formatNumberOnly(data.phone);
      }
      if (data.billPhone) {
        data.billPhone = formatNumberOnly(data.billPhone);
      }
      let billingPlan = {};
      let planInfo = paymentInfo.planList.filter(x => x.name === data.plan)
      paymentInfo.data[data.plan].forEach(i => {
        if (i.show_name === data.billing) {
          billingPlan = i;
        }
      });
      data.billingPlan = billingPlan;
      data.plan = planInfo.length ? planInfo[0].key : data.plan
      return store.dispatch((dispatch, getState) => saveDirectOrderInfoActions(dispatch, getState, data));
    }

    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }

  blurDotMc(stateType, e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);
    this.formatAsyncDotMcData(stateType, name, type, inputVal);
  }

  formatAsyncDotMcData(stateType, name, type, inputVal) {
    switch (type) {
      case 'dot': {
        if (!regDot.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 7),
            '',
            errorInfoConfig.dot.wrong,
            regDot,
            'companyDot');
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/dot/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: inputVal,
              companyMc: res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber
                ? res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber.slice(2)
                : '',
              company: res.identity.legalName,
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'companyDot');
            this.regData(
              stateType,
              data.company,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'company');
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'companyMc');
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.dot.wrong, inputVal, true);
          });
      }
      case 'mc': {
        if (!regMc.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 6),
            '',
            errorInfoConfig.mc.wrong,
            regMc,
            'companyMc');
        }
        return window.fetch(`https://api.truckerpath.com/services/saferwatch/mc/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: res['CarrierService.CarrierLookup'].CarrierDetails.dotNumber['#text'],
              companyMc: inputVal,
              company: res.identity.legalName,
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'companyDot');
            this.regData(
              stateType,
              data.company,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'company');
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'companyMc');
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.mc.wrong, inputVal, true);
          });
      }
    }
    return null;
  }

  handleChangeInput(stateType, e) {
    let val = e.target.value;
    const type = e.target.getAttribute('data-inputType');
    if (type === 'phone') {
      val = formatPhone(val);
    }
    if (type === 'zip') {
      if (this.state.billingInfo.billCountry === 'United States') {
        val = formatNumberOnly(val, 5);
      } else {
        val = formatCanadaZip(val);
      }
    }
    if (type === 'dot') {
      val = formatNumberOnly(val, 7);
    }
    if (type === 'mc') {
      val = formatNumberOnly(val, 6);
    }
    this.setState({
      [stateType]: {
        ...this.state[stateType],
        [e.target.name]: val,
      },
      formControl: {
        ...this.state.formControl,
        [e.target.name]: {
          error: '',
          onClick: false,
        },
      },
    });
  }

  handleToggle(stateType, e) {
    if (this.state[stateType][e.currentTarget.getAttribute('data-name')] === e.currentTarget.textContent) {
      return null;
    }

    this.processDataAndSetState(
      stateType,
      e.currentTarget.getAttribute('data-name'),
      '',
      e.currentTarget.textContent,
      true);

    // 如果toggle的是country init state 和zip 值
    if (e.currentTarget.getAttribute('data-name') === 'billCountry') {
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'billState', errorInfoConfig.text.empty, '', false);
      }, 0);
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'billZip', errorInfoConfig.text.empty, '', false);
      }, 0);
    }

    // 如果toggle的是billing
    if (e.currentTarget.getAttribute('data-name') === 'billing') {
      const priceVal = this.props.createAccount.paymentInfo.data[this.state.companyInfo.plan].filter(item => item.show_name == e.currentTarget.textContent)[0].discount_price;
      setTimeout(() => {
        this.processDataAndSetState(stateType,
          'discountPrice',
          '',
          priceVal,
          true);
      }, 0);
    }
    // 如果toggle的是Plan
    if (e.currentTarget.getAttribute('data-name') === 'plan') {
      const billingVal = this.props.createAccount.paymentInfo.data[e.currentTarget.textContent][0].show_name;
      const priceVal = this.props.createAccount.paymentInfo.data[e.currentTarget.textContent][0].discount_price;
      setTimeout(() => {
        this.processDataAndSetState(stateType,
          'billing',
          '',
          billingVal,
          true);
      }, 0);
      setTimeout(() => {
        this.processDataAndSetState(stateType,
          'discountPrice',
          '',
          priceVal,
          true);
      }, 0);
    }
    return null;
  }

  processDataAndSetState(stateType, typeName, errorTips, inputVal, clickType) {
    return this.setState({
      [stateType]: {
        ...this.state[stateType],
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }

  regData(stateType, inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) {
    if (!inputVal) {
      return this.processDataAndSetState(stateType, typeName, emptyErrorTips, inputVal, false);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(stateType, typeName, wrongErrorTips, inputVal, false);
    }
    return this.processDataAndSetState(stateType, typeName, '', inputVal, true);
  }

  handleBlur(stateType, e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'seatNumber': {
        return this.regData(
          stateType,
          nonZero(inputVal),
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'number': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal),
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'text': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'zip': {
        // 美国的zip格式
        if (
          (name.includes('company')
            && this.state[stateType].companyCountry
            && this.state[stateType].companyCountry === 'United States')
          || (name.includes('bill')
            && this.state[stateType].billCountry
            && this.state[stateType].billCountry === 'United States')
        ) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 5),
            errorInfoConfig.zip.empty,
            errorInfoConfig.zip.wrong,
            regZip,
            name
          );
        }

        // 加拿大的zip格式
        return this.regData(
          stateType,
          formatCanadaZip(inputVal),
          errorInfoConfig.zip.empty,
          errorInfoConfig.zip.wrong,
          regZipCanada,
          name
        );
      }
      case 'email': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name
        );
      }
      case 'phone': {
        return this.regData(
          stateType,
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name
        );
      }
      case 'notNeed': {
        return this.regData(
          stateType,
          inputVal,
          '',
          '',
          false,
          name
        );
      }
      case 'dot': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 7),
          '',
          errorInfoConfig.dot.wrong,
          regDot,
          'companyDot');
      }
      case 'mc': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 6),
          '',
          errorInfoConfig.mc.wrong,
          regMc,
          'companyMc');
      }
    }
    return null;
  }

  handleBlurContactEmailInput(stateType, e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'email': {
        if (regEmail.test(inputVal)) {
          store.dispatch((dispatch, getState) => queryAccountOrNot(dispatch, getState, inputVal));
        }
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name
        );
      }
    }
    return null;
  }

  changeDotOrMC(e) {
    const innerText = e.target.innerText;
    const showDot = (innerText === 'DOT');
    this.setState({
      showDotInput: showDot,
    });
  }

  getELDUser() {
    getELDUserInfo().then(res => {
      try {
        let eldUserInfo = {}
        if (res.status === 200) {
          const data = res.data.data
          const itemList = data.itemList
          if (itemList.indexOf('tl_makeorder') === -1) {
            eldUserInfo = {
              state: 'permissionDenied',
              isShow: false
            }
          } else {
            eldUserInfo = {
              state: 'success',
              isShow: true
            }
            this.setState({
              createAccountInfo: {
                ...this.state.createAccountInfo,
                salesCode: data.scCode
              }
            })
          }
        } else if (res.status === 401) {
          removeELDToken()
          location.href = config.eldUrl + '/login'
        } else {
          eldUserInfo = {
            state: 'serviceError',
            isShow: false
          }
        }
        this.setState({
          eldUserInfo: {
            ...this.state.eldUserInfo,
            ...eldUserInfo,
            requested: true
          }
        })
      } catch (error) {
        this.setState({
          eldUserInfo: {
            ...this.state.eldUserInfo,
            state: 'serviceError',
            isShow: false,
            requested: true
          }
        })
      }
    })
  }
}

export default connect(({
  createAccount,
}) => ({
  createAccount,
}), mapDispatch({
  getDirectOrderPayOption: () => getDirectOrderPayOption(),
}))(CreateAccount);



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/index.js